(function () {
  'use strict';
  var config = window.swissNutriLocaleCopy;
  if (!config || !config.ui) return;
  var dictionary = Object.create(null);
  function normalise(value) { return String(value || '').replace(/[’‘]/g, "'").replace(/\s+/g, ' ').trim(); }
  Object.keys(config.ui).forEach(function (source) { dictionary[normalise(source)] = config.ui[source]; });
  Object.keys(config.productTitles || {}).forEach(function (source) { dictionary[normalise(source)] = config.productTitles[source]; });
  function replace(raw) {
    var trimmed = normalise(raw);
    var translated = dictionary[trimmed];
    var quote = trimmed.match(/^([“"])(.*)([”"])$/);
    if (!translated && quote && dictionary[quote[2]]) translated = quote[1] + dictionary[quote[2]] + quote[3];
    var arrow = trimmed.match(/^(.*?)\s*(→)$/);
    if (!translated && arrow && dictionary[arrow[1]]) translated = dictionary[arrow[1]] + ' ' + arrow[2];
    var count = trimmed.match(/^(\d+)\s+(?:products|Produkte|produits|prodotti)$/i);
    if (!translated && count) translated = count[1] + ' ' + dictionary.products;
    if (!translated && trimmed.indexOf(': ') > -1) {
      var split = trimmed.indexOf(': ');
      var prefix = dictionary[trimmed.slice(0, split)];
      if (prefix) translated = prefix + trimmed.slice(split);
    }
    if (!translated || translated === trimmed) return raw;
    return raw.match(/^\s*/)[0] + translated + raw.match(/\s*$/)[0];
  }
  function skip(element) { return !element || !!element.closest('script,style,noscript,textarea,[contenteditable="true"],.shopify-policy__body'); }
  function text(node) {
    if (skip(node.parentElement)) return;
    var updated = replace(node.nodeValue);
    if (updated !== node.nodeValue) node.nodeValue = updated;
  }
  function attributes(element) {
    if (skip(element)) return;
    ['alt', 'title', 'aria-label', 'placeholder'].forEach(function (name) {
      var current = element.getAttribute(name);
      if (current === null) return;
      var updated = replace(current);
      if (updated !== current) element.setAttribute(name, updated);
    });
  }
  function apply(root) {
    if (root.nodeType === Node.TEXT_NODE) return text(root);
    if (root.nodeType === Node.ELEMENT_NODE) attributes(root);
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(text);
    if (root.querySelectorAll) root.querySelectorAll('[alt],[title],[aria-label],[placeholder]').forEach(attributes);
  }
  function localLinks(root) {
    if (!root.querySelectorAll) return;
    root.querySelectorAll('a[href]').forEach(function (link) {
      var url;
      try { url = new URL(link.getAttribute('href'), window.location.origin); } catch (_) { return; }
      if (url.origin !== window.location.origin || !/^\/(?:collections|products|pages|policies|blogs|cart|search)(?:\/|$)/.test(url.pathname)) return;
      link.setAttribute('href', '/' + config.locale + url.pathname + url.search + url.hash);
    });
  }
  function start() {
    apply(document.body); localLinks(document.body);
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData') text(mutation.target);
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === Node.ELEMENT_NODE || node.nodeType === Node.TEXT_NODE) apply(node);
          if (node.nodeType === Node.ELEMENT_NODE) localLinks(node);
        });
      });
    });
    observer.observe(document.body, {childList:true,subtree:true,characterData:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
})();
